import VideoInputControl from "@platform/features/videoUI/components/VideoUIControls/VideoInputControl";
import VideoInputTransformControl from "@platform/features/videoUI/components/VideoUIControls/VideoInputTransformControl";
import { useAppState } from "@platform/features/video/providers/AppStateProvider";
import { VideoFiltersCpuUtilization } from "@platform/features/video/types";
import { VideoUIContainerBreakpoints } from "../../videoUI.types";

export type Props = {
  containerBreakpoints: VideoUIContainerBreakpoints;
};

export function VideoUIControlsVideoInputContainer({
  containerBreakpoints,
}: Props) {
  const { videoTransformCpuUtilization } = useAppState();

  const videoTransformsEnabled =
    videoTransformCpuUtilization !== VideoFiltersCpuUtilization.Disabled;

  return videoTransformsEnabled ? (
    <VideoInputTransformControl containerBreakpoints={containerBreakpoints} />
  ) : (
    <VideoInputControl containerBreakpoints={containerBreakpoints} />
  );
}

export default VideoUIControlsVideoInputContainer;
